/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512 1024C229.23 1024 0 794.77 0 512S229.23 0 512 0s512 229.23 512 512-229.23 512-512 512zm0-928C282.258 96 96 282.258 96 512s186.258 416 416 416 416-186.258 416-416S741.742 96 512 96zm208.018 463.982h-160v160.036a48.018 48.018 0 01-96.036 0V559.982h-160a47.982 47.982 0 010-95.964h160v-160a48.018 48.018 0 0196.036 0v160h160a47.982 47.982 0 010 95.964z"/>'
  }
})
